import BikeAvailabilityStatusIcon from "./BikeAvailabilityStatusIcon";

export default BikeAvailabilityStatusIcon;
